import { render, staticRenderFns } from "./VocabularyTerm.vue?vue&type=template&id=12546182&scoped=true&"
import script from "./VocabularyTerm.vue?vue&type=script&lang=js&"
export * from "./VocabularyTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12546182",
  null
  
)

export default component.exports